import React, { useEffect, useRef, useState } from 'react';
import './AssignedSpace.css'
import './timePicker.css'
import Sidenav from './sidebar';
import { DatePicker, DatePickerProps } from 'antd';
import {
    Avatar,
    Menu,
    MenuTrigger,
    MenuList,
    MenuItem,
    MenuPopover,
} from "@fluentui/react-components";
import {
    AvatarGroup,
    AvatarGroupItem,
    AvatarGroupPopover,
} from "@fluentui/react-components";
import { Image } from "@fluentui/react-components";
import './work_place.css';
import './my-settings.css';
import { json, useNavigate } from 'react-router-dom';
import { getSettings } from '../../viewmodel/getsettings';
import { CommonInfo } from '../../CommonData/Config';
import moment from 'moment';
import { CustomTimePicker } from './timePicker';
import { CustomOptionsDropdown } from './dropdown';
import dayjs from 'dayjs';
import Greetings from './greeting';
import ToastrService from '../toaster/ToastrService';
import GetSettingsService from '../../APIService/mySettingsService';
import LoginService from '../../APIService/loginservice';
import Swal from 'sweetalert2'
import { faCog } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DeleteAction } from '../dialogues/dialogue-delete';
import ResourceSpaceTypeListService, { ResourceSpaceType, ResourceSpaceTypeListRequest } from '../../APIService/ResourceSpaceTypeListService';
import UserBookingService, { BookingCheckInRequest, BookingCheckOutRequest, CancelBookingRequest, ExtendBookingRequest, GetUserBookingRequest, UserBooking } from '../../APIService/UserBookingService';
import i18n from '../../utils/language'; // from language component
import { useTranslation } from 'react-i18next'
import { useTeamsContext } from '../../utils/useTeamsContext';
import ResourceSpaceTypeModel from '../ResourceSpaceType/ResourceSpaceTypeModel';
import UserBookings from './UserBookings';
import SearchService, { Equipment, GetEquipmentListResponse, GetTagsListResponse } from '../../APIService/SearchService';

const Commondata = CommonInfo;
const getSettingsData = getSettings;

interface WorkplaceException {
    Date: string;
    StartDateTime: string;
    EndDateTime: string;
    WorkingPlace: string;
    Id: any | null;
    Action: string;
}

export enum BookingCardAction {
    CheckIn,
    CheckOut,
    Cancel,
    Extend
}

const WorkPlacePage: React.FC = () => {
    const navigate = useNavigate();
    const theme = localStorage.getItem('Theme')
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const [lengthSet, setLength] = useState(0);
    const [isCalendarVisible, setCalendarVisible] = useState(false);
    const [selectedDate, setSelectedDate] = useState<Date>(new Date());
    const [selectedDatePicker, setSelectedDatePicker] = useState('');
    const [hoveredCard, setHoveredCard] = useState(null);
    const [isAddVisible, setIsAddVisible] = useState<boolean>(false);
    const [width, setWidth] = useState('100%'); // Initial width
    const is24HrFormat = getSettingsData.data && getSettingsData.data['Is24HrFormat'];
    const [show, setshowData] = useState(false);
    const [workplaceexceptions, setWorkplaceexceptions] = useState<WorkplaceException[]>([]);
    const [resourcespacetypeList, setResourcespacetypeList] = useState<ResourceSpaceType[]>([]);
    const [userBookings, setUserBookings] = useState<UserBooking[]>([]);
    const { themeString } = useTeamsContext();

    const [currentweekDates, setCurrentWeekDates] = useState<Date[]>([]);

    const { t } = useTranslation();

    useEffect(() => {
        console.log('SelectedDate state updated:', selectedDate);
    }, [selectedDate]);

    useEffect(() => {
        localStorage.setItem('Theme', themeString);
    }, [themeString]);

    const logOut = async () => {
        Swal.fire({
            title: t('LogoutConfirmation'),
            text: t('AreYouSureYouWantToLogout?'),
            icon: "warning",
            showCancelButton: true,
            cancelButtonText: t('No'),
            confirmButtonColor: localStorage.getItem('Theme') === 'dark' ? "#124779" : "#000",
            cancelButtonColor: localStorage.getItem('Theme') === 'dark' ? "rgba(238, 238, 238, 0.20)" : "#bcc6d0;",
            customClass: {
                popup: localStorage.getItem('Theme') === 'dark' ? 'dark-theme' : 'light-theme'
            },
            confirmButtonText: t("Yes")
        }).then(async (result) => {
            if (result.isConfirmed) {
                const LogOut = await LoginService.logout();
                if (LogOut.data.ErrCode === '') {
                    localStorage.setItem('loggedIn', 'false');
                    navigate('/login');
                }
            }
        });
    }

    const WeekDays: any[] = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

    const rearrangeWeekDays = (firstDay: string): string[] => {
        const index = WeekDays.indexOf(firstDay);
        if (index === -1) return WeekDays; // Return original array if the first day is not found
        return [...WeekDays.slice(index), ...WeekDays.slice(0, index)];
    };
    const storedValue = localStorage.getItem('Firstdayofweek');
    const firstDayOfWeek: any = storedValue === "null" ? 'Monday' : storedValue;
    const rearrangedWeekDays = rearrangeWeekDays(firstDayOfWeek);
    const [workLocations, setWorkLocations] = useState<{ [key: string]: { StartTime: string; EndTime: string; Place: string }[] }>(
        rearrangedWeekDays.reduce((acc, day) => ({ ...acc, [day]: [] }), {})
    );
    const open: any = localStorage.getItem('isOpen')

    const [Currentweek, SetCurrentWeek] = useState<string[]>([])
    const userIdString = localStorage.getItem('userId'); // userIdString is of type string | null
    let userId: any;
    if (userIdString !== null) {
        userId = parseInt(userIdString); // Parse the value as an integer
    } else {
    }
    const userEmail = localStorage.getItem('userEmail')
    const calendarRef = useRef<HTMLDivElement>(null);
    const [currentweek, showCurrentweek] = useState(false);
    useEffect(() => {
        const width = columnWidth(WeekDays.length);
        if (localStorage.getItem('Theme') === 'dark') {
            document.querySelectorAll('.ant-picker-panel-container').forEach((element) => {
                element.classList.add('Dark_calender'); // Removed the dot before the class name
            });
        }
        setWidth(width);
        getMySettings();
        initializeSelectedDate();
    }, []);

    useEffect(() => {
        if (isCalendarVisible) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isCalendarVisible]);

    useEffect(() => {
        const handleResize = () => setScreenWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        const open: any = localStorage.getItem('isOpen')
        if (lengthSet !== 0) {
            const width = columnWidth(lengthSet);
            setWidth(width);
        }
        return () => window.removeEventListener('resize', handleResize);
    }, [screenWidth]);
    let startDate: any;

    const getFirstDayOfWeek = (): string => {
        const stored = localStorage.getItem("Firstdayofweek");
        return stored && stored !== "null" ? stored : "Monday";
    };

    const getWorkingDays = (): Record<string, boolean> => {
        const stored = localStorage.getItem('Workingdays');
        return stored ? JSON.parse(stored) : {};
    };

    const getStartOfWeek = (baseDate: moment.Moment) => {
        const firstDay = getFirstDayOfWeek();
        let start = baseDate.clone().startOf('week').day(firstDay);

        if (start.isAfter(baseDate)) {
            start.subtract(1, 'week');
        }

        return start.startOf('day');
    };

    const getWorkingDatesOfWeek = (baseDate: moment.Moment): Date[] => {
        const startOfWeek = getStartOfWeek(baseDate);
        const workingDays = getWorkingDays();

        const weekDates: Date[] = [];

        for (let i = 0; i < 7; i++) {
            const date = startOfWeek.clone().add(i, 'days');
            const dayName = date.format('dddd');

            if (workingDays[dayName]) {
                weekDates.push(date.toDate());
            }
        }

        return weekDates;
    };

    const initializeSelectedDate = () => {
        const firstDayOfWeekString = getSettingsData.data.FirstDayOfWeek || localStorage.getItem('Firstdayofweek') || 'Sunday';
        const today = moment();
        let startOfWeek = today.clone().startOf('week').day(firstDayOfWeekString);

        // Adjust if the startOfWeek is after today, meaning we are in a new week
        if (startOfWeek.isAfter(today)) {
            startOfWeek.subtract(1, 'week');
        }
        startDate = getCurrentWeekDates(startOfWeek);
        setSelectedDate(today.toDate());
        console.log("SelectedDate: ", startDate);
        const weekDates = getWorkingDatesOfWeek(today);
        setCurrentWeekDates(weekDates);
    };

    const getCurrentWeekDates = (startOfWeek: any) => {
        const today = moment().startOf('day'); // Get today's date without time for comparison
        const weekDates = [];
        const workingDaysString: any = localStorage.getItem('Workingdays');
        const workingDays = workingDaysString ? JSON.parse(workingDaysString) : {};
        let firstValidDay: moment.Moment | null = null;
        for (let i = 0; i < 7; i++) {
            const date = startOfWeek.clone().add(i, 'days');
            const dayName = date.format('dddd');

            if (workingDays[dayName]) {
                if (!firstValidDay) {
                    firstValidDay = date.clone();
                }
                weekDates.push(date.toDate());
            }
        }
        const isAnyDateInWeekValid = weekDates.some(date => moment(date).isSameOrAfter(today));
        if (firstValidDay && isAnyDateInWeekValid) {
            return firstValidDay.toDate();
        } else {
            let nextWeekStart = startOfWeek.clone().add(1, 'week');
            for (let i = 0; i < 7; i++) {
                const date = nextWeekStart.clone().add(i, 'days');
                const dayName = date.format('dddd');

                if (workingDays[dayName]) {
                    return date.toDate();
                }
            }
        }
        return today.toDate();
    };


    const columnWidth = (length: any) => {
        setLength(length);
        if (screenWidth > 1000) {
            switch (length) {
                case 1:
                    return "99.75%";
                case 2:
                    return "49.75%";
                case 3:
                    return "32.93%";
                case 4:
                    return "24.6%";
                case 5:
                    return "19.6%";
                case 6:
                    return "16.5%";
                case 7:
                    return "13.9%";
                default:
                    return "100%";
            }
        } else {
            switch (length) {
                case 1:
                    return "99.75%";
                case 2:
                    return "49.75%";
                case 3:
                    return "32.93%";
                case 4:
                    return "32.93%";
                case 5:
                    return "32.93%";
                case 6:
                    return "32.93%";
                case 7:
                    return "32.93%";
                default:
                    return "100%";
            }
        }
    };


    const getMySettings = async () => {
        try {
            const getDataResult = await GetSettingsService.getMySettings(userId, userEmail);
            if (getDataResult.data.d) {
                getSettingsData.data = getDataResult.data.d;
                localStorage.setItem('Firstdayofweek', getDataResult.data.d.FirstDayOfWeek);
                localStorage.setItem('DateFormat', getDataResult.data.d.DateFormat)
                getSettingsData.data.Departments = getDataResult.data.d.Departments;
                CommonInfo.workingDays = getSettingsData.data.WorkingDays
                await GetMySettingsBasic();

            }
        } catch (error) {
        }
    };

    const GetMySettingsBasic = async (date?: Date) => {
        try {
            const getResult = await GetSettingsService.GetSettingsBasic(userId, userEmail);
            if (getResult.data.d) {

                getSettingsData.MysettingsBasicdata = getResult.data.d;
                GetWorkPlacesList()
                GetWorklocation();
                getResourceSpaceTypes();
                console.log("Selected Date: ", date ?? new Date());
                getUserBookingsApi(moment(date ?? moment()).format('DD/MM/YYYY HH:mm:ss'));

                if (Array.isArray(getSettingsData.data.Departments) && getSettingsData.data.Departments.length > 0) {
                    getSettingsData.data.Departments.forEach((d: any) => {
                        if (Array.isArray(getSettingsData.MysettingsBasicdata[0].Teams)) {
                            getSettingsData.MysettingsBasicdata[0].Teams.forEach((t: any) => {

                                if (Array.isArray(t.Members)) {
                                    t.Members.forEach((members: any) => {
                                        const firstNameParts = members.FirstName.trim().split(" ");
                                        const firstInitial = firstNameParts[0][0]; // First letter of the first word
                                        const secondInitial = firstNameParts.length > 1
                                            ? firstNameParts[1][0] // First letter of the second word (if exists)
                                            : members.LastName ? members.LastName[0] : ''; // First letter of LastName (if exists)

                                        const initials = firstInitial + secondInitial;
                                        members.name = initials; // Combine initials
                                        t.Members = t.Members // Exclude the team leader from the sorting
                                            .sort((a: any, b: any) => {
                                                const nameA = a.FirstName.toLowerCase(); // Convert to lower case for case insensitive sorting
                                                const nameB = b.FirstName.toLowerCase();
                                                return nameA.localeCompare(nameB);
                                            });
                                    });
                                }

                                if (d.Teams && d.Teams.includes(t.Id)) {
                                    t.department = d.Name;
                                }
                            });
                        }
                    });
                } else {
                    getSettingsData.MysettingsBasicdata[0].Teams.forEach((t: any) => {

                        if (Array.isArray(t.Members)) {
                            t.Members.forEach((members: any) => {
                                const firstNameParts = members.FirstName.trim().split(" ");
                                const firstInitial = firstNameParts[0][0]; // First letter of the first word
                                const secondInitial = firstNameParts.length > 1
                                    ? firstNameParts[1][0] // First letter of the second word (if exists)
                                    : members.LastName ? members.LastName[0] : ''; // First letter of LastName (if exists)

                                const initials = firstInitial + secondInitial;
                                members.name = initials; // Combine initials
                                t.Members = t.Members // Exclude the team leader from the sorting
                                    .sort((a: any, b: any) => {
                                        const nameA = a.FirstName.toLowerCase(); // Convert to lower case for case insensitive sorting
                                        const nameB = b.FirstName.toLowerCase();
                                        return nameA.localeCompare(nameB);
                                    });
                            });
                        }


                    });
                }

            }


        } catch (error) {

        }
    }

    const GetTeamLeaderData = async () => {
        try {
            const teamLeadersPromises = getSettingsData.MysettingsBasicdata[0].Teams
                .filter((t: any) => t.TeamLeader !== 0) // Filter out teams with no team leader
                .map(async (t: any) => {
                    try {
                        const getDataResult = await GetSettingsService.getMySettings(t.TeamLeader, userEmail);
                        if (getDataResult.data.d) {
                            const teamLeaderData = getDataResult.data.d;

                            // Get initials from the Team Leader's first and last name
                            const firstNameParts = teamLeaderData.FirstName.trim().split(" ");
                            const firstInitial = firstNameParts[0][0]; // First letter of first name
                            const secondInitial = firstNameParts.length > 1
                                ? firstNameParts[1][0] // First letter of the second name
                                : teamLeaderData.LastName ? teamLeaderData.LastName[0] : ''; // First letter of LastName

                            const initials = firstInitial + secondInitial;

                            // Add the team leader's initials and image to the team object
                            t.teamLeadername = initials;
                            t.UserImage = teamLeaderData.UserImage ? teamLeaderData.UserImage.Value : null;

                            // Create the team leader member object
                            const teamLeaderMember = {
                                Id: t.TeamLeader,
                                FirstName: teamLeaderData.FirstName,
                                LastName: teamLeaderData.LastName,
                                name: initials,
                                UserImage: teamLeaderData.UserImage ? teamLeaderData.UserImage.Value : null
                            };

                            // Add the team leader to the beginning of the Members array
                            t.Members = [
                                teamLeaderMember,
                                ...t.Members.filter((member: any) => member.Id !== t.TeamLeader) // Filter out the team leader from Members if already present
                            ];

                            // Sort members alphabetically by FirstName (excluding the team leader)
                            t.Members = t.Members.slice(1) // Exclude the team leader from the sorting
                                .sort((a: any, b: any) => {
                                    const nameA = a.FirstName.toLowerCase(); // Convert to lower case for case insensitive sorting
                                    const nameB = b.FirstName.toLowerCase();
                                    return nameA.localeCompare(nameB);
                                });

                            // Prepend the team leader back to the sorted members array
                            t.Members.unshift(teamLeaderMember);
                            console.log("t.Members", t.Members);

                            return { initials, teamLeaderData };
                        }
                    } catch (error) {
                        return null;
                    }
                });

            // Wait for all promises to resolve
            await Promise.all(teamLeadersPromises);

            // Log the updated Teams array to confirm changes
        } catch (error) {
            console.error('Error in GetTeamLeaderData:', error);
        }
    };


    const GetWorkPlacesList = async () => {
        try {
            const data =
            {
                "UserId": userId,
                "EmailAddress": userEmail,
                "LocationId": getSettingsData.data.DefaultLocation?.LocationId ? getSettingsData.data.DefaultLocation?.LocationId : null

            }

            const getResult = await GetSettingsService.GetWorkPlacesList(data);
            if (getResult.data.d) {
                getSettingsData.workPlacelist = getResult.data.d.WorkPlaces;
                if (getSettingsData.workPlacelist.length <= 0) {
                    getSettingsData.workPlacelist = [
                        {
                            Id: 0,
                            Name: t('NoDataAvailable'),
                            IconPath: "",
                            LocationId: 0
                        }
                    ]

                }


            }
        } catch (error) {

        }
    }

    const GetWorklocation = async () => {
        const dateRange = getWeekDates();
        try {
            let data = {
                Id: userId,
                EmailAddress: userEmail,
                Date: moment(dateRange.startDate).format('DD/MM/YYYY'),
                StartDateTime: moment(dateRange.startDate, 'YYYY-MM-DD ').format('DD/MM/YYYY HH:mm'),
                EndDateTime: moment(dateRange.endDate, 'YYYY-MM-DD').add(1, 'day').format('DD/MM/YYYY HH:mm'),

            }
            const getResult = await GetSettingsService.GetWorkLocation(data);
            if (getResult.data.d) {
                getSettingsData.GetWorkLocationdata = getResult.data.d;
                await GetTeamLeaderData();
                getWorkplaces()
                console.log("getSettingsData.MysettingsBasicdata[0].Teams", getSettingsData.MysettingsBasicdata[0].Teams);

            }
        } catch (error) {

        }
    }

    const getResourceSpaceTypes = async (forLocationId?: number) => {
        try {
            const getResourceSpaceTypeListRequest: ResourceSpaceTypeListRequest = { LocationId: forLocationId }
            const resourceSpaceTypeList = await ResourceSpaceTypeListService.getResourceSpaceTypeList(forLocationId ? getResourceSpaceTypeListRequest : null);
            setResourcespacetypeList(resourceSpaceTypeList);
        } catch (error) {
            console.log("getResourceSpaceTypeList Error: ", JSON.stringify(error));
        }
    };

    const getUserBookingsApi = async (date?: string) => {
        try {

            let getUserBookingsRequest: GetUserBookingRequest = {};
            getUserBookingsRequest.Id = [userId]
            if (userEmail) { getUserBookingsRequest.EmailAddress = userEmail }
            if (date) { getUserBookingsRequest.Date = date }

            const userBookings = await UserBookingService.getUserBookings(getUserBookingsRequest);
            setUserBookings(userBookings);
        } catch (error) {
            console.log("getResourceSpaceTypeList Error: ", JSON.stringify(error));
        }
    };

    function getWeekDates() {
        const storedValue = localStorage.getItem('Firstdayofweek');
        const firstDayOfWeekStr = storedValue === "null" ? 'Sunday' : storedValue; // Default to Sunday

        // Map string day names to numbers (0 = Sunday, 1 = Monday, ..., 6 = Saturday)
        const dayMap: { [key: string]: number } = {
            'Sunday': 0, 'Monday': 1, 'Tuesday': 2, 'Wednesday': 3,
            'Thursday': 4, 'Friday': 5, 'Saturday': 6
        };

        const firstDayOfWeek = dayMap[firstDayOfWeekStr ? firstDayOfWeekStr : "Monday"] ?? 0; // Default to Sunday (0) if invalid

        // Convert startDate to a moment object
        const selectedMoment = moment(startDate, 'YYYY-MM-DD').startOf('day');

        // Find the start of the week based on the selected first day
        let startOfWeek = selectedMoment.clone().day(firstDayOfWeek);

        // If selected date is before the computed startOfWeek, move back a week
        if (selectedMoment.day() < firstDayOfWeek) {
            startOfWeek.subtract(7, 'days');
        }

        // Generate week dates
        const weekDates: string[] = [];
        for (let i = 0; i < 7; i++) {
            weekDates.push(startOfWeek.clone().add(i, 'days').format('YYYY-MM-DD'));
        }

        console.log("weekDates", weekDates);

        SetCurrentWeek(weekDates); // Update your state

        return {
            startDate: weekDates[0],
            endDate: weekDates[6],
            CurrentWeek: weekDates.map(date => moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY'))
        };
    }

    const [Workplaces, SetWorkplaces] = useState(false)

    const getWorkplaces = () => {
        const workingDays = getSettingsData.MysettingsBasicdata[0]?.WorkingDays;
        const initialWorkLocations = getSettingsData.GetWorkLocationdata.DefaultWorkPlaces;
        Object.keys(initialWorkLocations).forEach(day => {
            initialWorkLocations[day].forEach((v: any) => {
                v.StartTime = formatDateToTimeString(moment(v.StartTime, 'HH:mm').toDate());
                v.EndTime = formatDateToTimeString(moment(v.EndTime, 'HH:mm').toDate());
                v.WorkplaceException = getSettingsData.GetWorkLocationdata.WorkPlaceExceptions == null ? true : false;
                v.Id = 0;

            });
        });
        const selectedMoment = moment(startDate, 'YYYY-MM-DD').startOf('day');
        const weekDates: any = [];
        const startOfWeek = selectedMoment.clone().startOf('week');
        for (let i = 0; i < 7; i++) {
            weekDates.push(startOfWeek.clone().add(i, 'days').format('DD/MM/YYYY'));
        }
        const targetDateFormatted = rearrangedWeekDays.map((day, i) => {
            const date = startDate ? getDateWithOrginal(startDate, day, i)?.targetDate : null;
            return date ? date.format('DD/MM/YYYY') : null;
        }).filter(date => date !== null);

        const exceptions = getSettingsData.GetWorkLocationdata.WorkPlaceExceptions?.filter((exception: any) => {
            return exception.Date && targetDateFormatted.includes(exception.Date);
        }) || [];
        const groupedExceptions = exceptions.reduce((acc: any, exception: any) => {
            const date = exception.Date;
            if (!acc[date]) {
                acc[date] = [];
            }
            acc[date].push(exception);
            return acc;
        }, {});

        let updatedWorkLocations = { ...initialWorkLocations };

        Object.keys(groupedExceptions).forEach(date => {

            if (groupedExceptions[date].length > 0) {
                groupedExceptions[date].forEach((exception: any) => {
                    const momentDate = moment(date, 'DD/MM/YYYY');
                    if (momentDate.isValid()) {
                        const day = momentDate.format('dddd');
                        const startTime = getSettingsData.data.Is24HrFormat
                            ? moment(exception.StartDateTime, 'DD/MM/YYYY HH:mm:ss').format('H:mm')
                            : moment(exception.StartDateTime, 'DD/MM/YYYY HH:mm:ss').format('h:mm A');
                        const endTime = getSettingsData.data.Is24HrFormat
                            ? moment(exception.EndDateTime, 'DD/MM/YYYY HH:mm:ss').format('H:mm')
                            : moment(exception.EndDateTime, 'DD/MM/YYYY HH:mm:ss').format('h:mm A');
                        const newLocation = {
                            StartTime: startTime,
                            EndTime: endTime,
                            Place: exception.WorkingPlace,
                            WorkplaceException: true,
                            Id: exception.Id
                        };
                        updatedWorkLocations[day] = updatedWorkLocations[day] || [];
                        updatedWorkLocations[day].push(newLocation);
                    } else {
                    }
                });
            } else {
                updatedWorkLocations = { initialWorkLocations };
            }
        });
        const filteredDefaultWorkPlaces = Object.keys(updatedWorkLocations).reduce((acc: any, day) => {
            acc[day] = workingDays[day] ? updatedWorkLocations[day] : [];
            return acc;
        }, {});

        const Workplaces: any = {};

        Object.keys(filteredDefaultWorkPlaces).forEach(day => {
            const entries = filteredDefaultWorkPlaces[day];
            const hasTrueException = entries.some((entry: any) => entry.WorkplaceException);
            Workplaces[day] = hasTrueException
                ? entries.filter((entry: any) => entry.WorkplaceException).sort(compareTimes)
                : entries.sort(compareTimes);
        });
        const hasWorkingDays = Object.values(workingDays).includes(true);
        const allDaysEmpty = Object.keys(filteredDefaultWorkPlaces).every(day => filteredDefaultWorkPlaces[day].length === 0);
        console.log("Workplaces", Workplaces);
        setWorkLocations(Workplaces);
        setWorkplaceexceptions(getSettingsData.GetWorkLocationdata?.WorkPlaceExceptions ? getSettingsData.GetWorkLocationdata?.WorkPlaceExceptions : []);
        // Determine if there's data to show and set column width
        const isEmpty = Object.values(updatedWorkLocations).every((locations: any) => locations.length === 0);
        if (Object.values(workingDays).includes(true)) {
            setshowData(false)
        }
        else {
            setshowData(true)

        }
        if ((hasWorkingDays && allDaysEmpty) || !hasWorkingDays) {
            setshowData(true);
            SetWorkplaces(true);
        }
        const trueCount = Object.values(workingDays).filter(value => value === true).length;
        const width = columnWidth(trueCount);
        setWidth(width);

    };

    const formatDateToTimeString = (date: any) => {
        const hours = date.getHours();
        const minutes = date.getMinutes();
        const ampm = hours >= 12 ? "PM" : "AM";
        const formattedHours = hours % 12 || 12; // Convert hours to 12-hour format
        const formattedMinutes = minutes < 10 ? "0" + minutes : minutes;
        const timeString = `${formattedHours}:${formattedMinutes} ${ampm}`;

        return getSettingsData.data['Is24HrFormat'] ? `${hours}:${formattedMinutes}` : timeString;
    };

    const compareTimes = (a: any, b: any) => {
        const parseTime = (timeStr: any) => {
            const [time, modifier] = timeStr.split(' ');
            let [hours, minutes] = time.split(':').map(Number);
            if (modifier === 'PM' && hours < 12) hours += 12;
            if (modifier === 'AM' && hours === 12) hours = 0;
            return { hours, minutes };
        };

        const startA = parseTime(a.StartTime);
        const startB = parseTime(b.StartTime);
        if (startA.hours !== startB.hours) {
            return startA.hours - startB.hours;
        }
        return startA.minutes - startB.minutes;
    };


    const setDateFormat = () => {
        let newFormattype;
        switch (getSettingsData.data.DateFormat) {
            case ('dd/MM/yyyy'):
                return newFormattype = 'DD/MM/YYYY';
            case ('MM/DD/YYYY'):
                return newFormattype = 'MM/DD/YYYY';
            case ('MMMM, DD, YYYY'):
                return newFormattype = 'MMMM, DD, YYYY';
            case ('MMMM, dddd D, YYYY'):
                return newFormattype = 'MMMM, dddd D, YYYY';

            case ('dddd, D MMMM YYYY'):
                return newFormattype = 'dddd, D MMMM YYYY';
            case ('dddd Do MMMM YYYY'):
                return newFormattype = 'dddd Do MMMM YYYY';

            default:
                return newFormattype = 'DD/MM/YYYY';

        }
    }
    const dateFormat = setDateFormat();

    const convertToTimeString = (timeString: string) => {
        const [timePart, period] = timeString.split(' ');
        let [hours, minutes] = timePart.split(':').map(Number);

        if (period && period.toUpperCase() === 'PM') {
            hours = hours === 12 ? 12 : hours + 12;
        } else if (period && period.toUpperCase() === 'AM') {
            hours = hours === 12 ? 0 : hours;
        }

        const date = new Date();
        date.setHours(hours);
        date.setMinutes(minutes);
        const formattedHours = date.getHours().toString().padStart(2, '0');
        const formattedMinutes = date.getMinutes().toString().padStart(2, '0');
        return `${formattedHours}:${formattedMinutes}`;
    };

    const isDayDisabled = (date: any) => {
        const workingDays = getSettingsData.MysettingsBasicdata[0]?.WorkingDays || {};
        const dayOfWeek = dayjs(date).format('dddd');
        return workingDays[dayOfWeek] === false;
    };

    const handleIconClick = () => {
        if (localStorage.getItem('Theme') === 'dark') {
            document.body.classList.add('dark-theme');

        }
        setCalendarVisible(!isCalendarVisible);
    };

    const datePickerRef = useRef<HTMLDivElement>(null);
    const iconRef = useRef<HTMLSpanElement>(null);
    const handleClickOutside = (event: any) => {
        if (calendarRef.current && !calendarRef.current.contains(event.target)) {
            setCalendarVisible(false);
        }
    };


    const handleDatePickOpen = () => {
        if (isCalendarVisible) {
            setCalendarVisible(false);
        }
    }

    const handleCardHover = (index: any) => {
        setHoveredCard(index);
        setIsAddVisible(true);
    };

    const handleMouseLeave = () => {
        setHoveredCard(null);
        setIsAddVisible(false);
    };

    const setTodayDate = async () => {
        const today = moment().startOf('day').toDate();
        const weekDates = getWorkingDatesOfWeek(moment());
        setCurrentWeekDates(weekDates);
        today.setHours(0);
        today.setMinutes(0);
        today.setSeconds(0);
        today.setMilliseconds(0);
        startDate = today;
        setSelectedDate(today);
        setSelectedDatePicker(moment(today).format('YYYY-MM-DD'));
        showCurrentweek(true);
        await getMySettings();
    };

    const getNextEnabledDate = (date: any, increment: any, WorkingDays: any) => {
        let nextDate = new Date(date);
        const enabledDays = Object.values(WorkingDays).some(day => day !== false);

        if (!enabledDays) {
            // Handle the case where all working days are false
            ToastrService.warning(t('PleaseConfigureDefaultWorkplaces'));
        }
        else {
            while (true) {
                nextDate.setDate(nextDate.getDate() + increment);
                const dayOfWeek = nextDate.toLocaleDateString('en-US', { weekday: 'long' });
                if (WorkingDays[dayOfWeek] !== false) {
                    return nextDate;
                }
            }
        }


    };

    const isSameDay = (d1: Date, d2: Date) => moment(d1).isSame(d2, 'day');

    const setRightLeftDate = async (type: 'left' | 'right') => {
        try {
            const workingDays = getSettingsData.MysettingsBasicdata[0]?.WorkingDays;
            setCalendarVisible(false);
            let givenDate = selectedDate ? new Date(selectedDate) : null;
            let oneDayLaterOrEarlier: any = givenDate ? new Date(givenDate) : null;

            if (type === 'left') {
                oneDayLaterOrEarlier = getNextEnabledDate(oneDayLaterOrEarlier, -7, workingDays);
            } else {
                oneDayLaterOrEarlier = getNextEnabledDate(oneDayLaterOrEarlier, 7, workingDays);
            }

            oneDayLaterOrEarlier?.setHours(0);
            oneDayLaterOrEarlier?.setMinutes(0);
            oneDayLaterOrEarlier?.setSeconds(0);
            oneDayLaterOrEarlier?.setMilliseconds(0);
            startDate = oneDayLaterOrEarlier;
            const weekDates = getWorkingDatesOfWeek(moment(oneDayLaterOrEarlier));
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            const todayInWeek = weekDates.find(d => isSameDay(d, today));
            const finalSelectedDate = todayInWeek ?? weekDates[0];
            setSelectedDate(finalSelectedDate);
            setCurrentWeekDates(weekDates);
            setSelectedDatePicker(moment(finalSelectedDate).format('YYYY-MM-DD'));
            await GetMySettingsBasic(finalSelectedDate);
        } catch (error) {
            // Handle the error here, e.g., show a message to the user
            ToastrService.warning(t('NoWorkingDaysAreEnabledPleaseEnableAtLeastOneWorkingDay'));
        }
    };

    const handleTimeChange = (day: string, index: number, type: 'StartTime' | 'EndTime', time: any) => {
        const today = moment();
        let startOfWeek = today.clone().startOf('week').day(day);

        if (time.selectedTime !== null) {
            const formattedTime = formatDateToTimeString(time.selectedTime); // Use the formatting function
            const newTime = formattedTime;
            const existingStartTimes = workLocations[day].map(loc => loc.StartTime);
            const existingEndTimes = workLocations[day].map(loc => loc.EndTime);
            const selectedStartTime = getSettingsData.data['Is24HrFormat'] ? moment(existingStartTimes[index], 'HH:mm') : moment(existingStartTimes[index], 'hh:mm A');
            const selectedEndTime = getSettingsData.data['Is24HrFormat'] ? moment(existingEndTimes[index], 'HH:mm') : moment(existingEndTimes[index], 'hh:mm A');
            const newselectedTime = getSettingsData.data['Is24HrFormat'] ? moment(newTime, 'HH:mm') : moment(newTime, 'hh:mm A');

            const isStartDuplicate = existingStartTimes.some((startTime, i) => i !== index && startTime === formattedTime);
            const isEndDuplicate = existingEndTimes.some((endTime, i) => i !== index && endTime === formattedTime);

            if (type === 'StartTime' && isStartDuplicate) {
                ToastrService.warning(t('TheSameStartTimeForTheSameDayHasAlreadyBeenSelected'));
                return;
            }

            if (type === 'EndTime' && isEndDuplicate) {
                ToastrService.warning(t('TheSameEndTimeForTheSameDayHasAlreadyBeenSelected'));
                return;
            }

            if (type === 'StartTime' && selectedStartTime && selectedEndTime && newselectedTime.isAfter(selectedEndTime)) {
                ToastrService.warning(t('StartTimeMustBeEarlierThanTheEndTime'));
                return;
            }
            if (type === 'StartTime' && selectedEndTime && (newselectedTime.isSame(selectedEndTime))) {
                ToastrService.warning(t('StartTimeAndEndTimeCannotBeTheSame'));
                return;
            }

            if (type === 'EndTime' && selectedStartTime && (newselectedTime.isSame(selectedStartTime))) {
                ToastrService.warning(t('StartTimeAndEndTimeCannotBeTheSame'));
                return;
            }

            if (type === 'EndTime' && selectedStartTime && selectedEndTime && newselectedTime.isBefore(selectedStartTime)) {
                ToastrService.warning(t('EndTimeMustBeLaterThanTheStartTime'));
                return;
            }

            let updatedWorkLocations = [...workLocations[day]];

            if (type === 'StartTime') {
                updatedWorkLocations = updatedWorkLocations.map((loc, i) => {
                    if (i !== index) {
                        const existingStartTime = getSettingsData.data['Is24HrFormat'] ? moment(loc.StartTime, 'HH:mm') : moment(loc.StartTime, 'hh:mm A');
                        const existingEndTime = getSettingsData.data['Is24HrFormat'] ? moment(loc.EndTime, 'HH:mm') : moment(loc.EndTime, 'hh:mm A');
                        if (newselectedTime.isBetween(existingStartTime, existingEndTime, null, '[)')) {
                            return {
                                ...loc,
                                EndTime: newselectedTime.format(getSettingsData.data['Is24HrFormat'] ? 'HH:mm' : 'hh:mm A'), // Update format based on is24HrFormat
                            };
                        }
                    }
                    return loc;
                });
            }

            const newStartTime = type === 'StartTime' ? newselectedTime : selectedStartTime;
            const newEndTime = type === 'EndTime' ? newselectedTime : selectedEndTime;

            const isWithinRange = updatedWorkLocations.some((loc, i) => {
                if (i !== index) {
                    const existingStartTime = getSettingsData.data['Is24HrFormat'] ? moment(loc.StartTime, 'HH:mm') : moment(loc.StartTime, 'hh:mm A');
                    const existingEndTime = getSettingsData.data['Is24HrFormat'] ? moment(loc.EndTime, 'HH:mm') : moment(loc.EndTime, 'hh:mm A');

                    return (
                        newStartTime.isBetween(existingStartTime, existingEndTime, null, '[)') ||
                        newEndTime.isBetween(existingStartTime, existingEndTime, null, '(]') ||
                        (newStartTime.isBefore(existingStartTime) && newEndTime.isAfter(existingEndTime))
                    );
                }
                return false;
            });

            if (isWithinRange) {
                ToastrService.warning(t('TheSelectedTimeIsWithinexistingtimeRangeForTheSameDay'));
                return;
            }
            const currentWeekDates = Currentweek;
            let selectedDate: any | null = null;

            // Find the date corresponding to the given day
            currentWeekDates.forEach((date: string) => {
                if (moment(date).format('dddd') === day) {
                    selectedDate = moment(date).format('DD/MM/YYYY');
                }
            });

            if (!selectedDate) {
                return;
            }

            setWorkLocations(prevLocations => {
                const updatedLocations = {
                    ...prevLocations,
                    [day]: prevLocations[day].map((loc, i) => (i === index ? { ...loc, [type]: formattedTime, Date: selectedDate } : loc))
                };

                let prevExceptions = [];
                const existingExceptions = workplaceexceptions || []

                const isDateInExceptions = existingExceptions.some(existingExc => existingExc.Date === selectedDate);

                if (!isDateInExceptions) {
                    prevExceptions = convertData(updatedLocations[day], selectedDate);
                }

                const filteredExceptions = prevExceptions.filter((prevExc: any) => {
                    return !existingExceptions.some(existingExc => {
                        return prevExc.Date === existingExc.Date &&
                            prevExc.StartDateTime === existingExc.StartDateTime &&
                            prevExc.EndDateTime === existingExc.EndDateTime;
                    });
                });

                let updatedExceptions: WorkplaceException[] = [];

                if (filteredExceptions.length !== 0) {
                    filteredExceptions.forEach((exception: any) => {
                        if (exception.Id !== null) {
                            updatedExceptions.push({
                                ...exception,
                                Date: exception.Date,
                                StartDateTime: convertTimeString(updatedLocations[day][index].StartTime, selectedDate),
                                EndDateTime: convertTimeString(updatedLocations[day][index].EndTime, selectedDate),
                                WorkingPlace: updatedLocations[day][index].Place,
                                Action: 'Edit',
                                Id: exception.Id
                            });
                        } else {
                            const newException: WorkplaceException = {
                                Date: selectedDate,
                                StartDateTime: convertTimeString(updatedLocations[day][index].StartTime, selectedDate),
                                EndDateTime: convertTimeString(updatedLocations[day][index].EndTime, selectedDate),
                                WorkingPlace: updatedLocations[day][index].Place,
                                Id: null, // Set ID as null for new exception
                                Action: 'Add'
                            };

                            updatedExceptions = [...filteredExceptions, newException];
                        }
                    });
                } else {
                    existingExceptions.forEach((exception: any) => {
                        if (exception.Date === selectedDate && exception.StartDateTime === convertTimeString(prevLocations[day][index].StartTime, selectedDate) || exception.EndDateTime === convertTimeString(prevLocations[day][index].EndTime, selectedDate)) {
                            if (exception.Id !== null) {
                                updatedExceptions.push({
                                    ...exception,
                                    Date: exception.Date,
                                    StartDateTime: convertTimeString(updatedLocations[day][index].StartTime, selectedDate),
                                    EndDateTime: convertTimeString(updatedLocations[day][index].EndTime, selectedDate),
                                    WorkingPlace: updatedLocations[day][index].Place,
                                    Action: 'Edit',
                                    Id: exception.Id
                                });
                            } else {
                                const newException: WorkplaceException = {
                                    Date: selectedDate,
                                    StartDateTime: convertTimeString(updatedLocations[day][index].StartTime, selectedDate),
                                    EndDateTime: convertTimeString(updatedLocations[day][index].EndTime, selectedDate),
                                    WorkingPlace: updatedLocations[day][index].Place,
                                    Id: null, // Set ID as null for new exception
                                    Action: 'Add'
                                };

                                updatedExceptions = [...workplaceexceptions, newException];
                            }
                        }
                    });
                }

                setWorkplaceexceptions(updatedExceptions);

                // Call updateWorkLocations with the new state
                updateWorkLocations(updatedLocations, updatedExceptions);
                return updatedLocations;
            });

        };
    }

    const updateWorkLocations = async (updatedWorkLocations: any, newException: any) => {
        // Convert start and end times to strings
        const initialWorkLocations = getSettingsData.data.DefaultWorkPlaces;
        for (const day in initialWorkLocations) {
            if (initialWorkLocations.hasOwnProperty(day)) {
                const updatedTimes = initialWorkLocations[day].map((item: any) => ({
                    ...item,
                    StartTime: convertToTimeString(item.StartTime),
                    EndTime: convertToTimeString(item.EndTime)
                }));
                initialWorkLocations[day] = updatedTimes;
            }
        }

        // Helper function to remove duplicates based on StartDateTime, EndDateTime, and Date
        const removeDuplicates = (exceptions: any) => {
            const uniqueItems = new Map();
            exceptions.forEach((exception: any) => {
                const key = `${exception.StartDateTime}-${exception.EndDateTime}-${exception.Date}`;
                if (!uniqueItems.has(key)) {
                    uniqueItems.set(key, exception);
                }
            });
            return Array.from(uniqueItems.values());
        };

        let workPlaceExceptions;
        if (newException.some((exception: any) => exception.Action === "Add")) {
            const uniqueExceptions = removeDuplicates(newException);
            workPlaceExceptions = uniqueExceptions.filter((exception: any) =>
                exception.Id === null &&
                exception.Action === "Add" &&
                !exception.EndDateTime.includes('NaN')
            );
        } else {
            workPlaceExceptions = (
                newException[0].Id !== null &&
                newException[0].Action &&
                !newException[0].EndDateTime.includes('NaN')
            ) ? [newException[0]] : [];
        }

        try {
            const data = {
                Id: userId,
                EmailAddress: userEmail,
                DefaultWorkPlaces: initialWorkLocations,
                WorkPlaceExceptions: workPlaceExceptions
            };

            const getDataResult = await GetSettingsService.SetWorklocation(data);
            if (getDataResult.data && getDataResult.data?.Updated) {
                ToastrService.success(t('YourWorkPlacesHaveBeenSaved'));
                GetWorklocations();
            } else {
                ToastrService.error(getDataResult.data?.ErrDesc);
            }
        } catch (error) {
        }
    };

    const GetWorklocations = async () => {
        // const dateRange = Currentweek;
        try {
            let data = {
                Id: userId,
                EmailAddress: userEmail,
                Date: moment(Currentweek[0]).format('DD/MM/YYYY'),
                StartDateTime: moment(Currentweek[0], 'YYYY-MM-DD ').format('DD/MM/YYYY HH:mm'),
                EndDateTime: moment(Currentweek[Currentweek.length - 1], 'YYYY-MM-DD   ').add(1, 'day').format('DD/MM/YYYY HH:mm'),
            }
            const getResult = await GetSettingsService.GetWorkLocation(data);
            if (getResult.data.d) {
                getSettingsData.GetWorkLocationdata = getResult.data.d;
                startDate = Currentweek[0];
                await getWorkplaces()

            }
        } catch (error) {

        }
    }

    const handleDateSelect: DatePickerProps['onChange'] = async (date: any, dateString: any) => {
        const selectedDate = moment(date.$d).startOf('day');
        const weekDates = getWorkingDatesOfWeek(selectedDate);
        setCurrentWeekDates(weekDates);
        setSelectedDate(selectedDate.toDate())
        startDate = selectedDate.toDate()
        setSelectedDatePicker(selectedDate.format('YYYY-MM-DD'));
        setCalendarVisible(false);
        showCurrentweek(true);
        await GetMySettingsBasic(selectedDate.toDate());
    };

    const handleDropdownChange = async (day: string, index: number, Place: any, event: any) => {

        const currentWeekDates = Currentweek;
        let selectedDate: any | null = null;

        // Find the date corresponding to the given day
        currentWeekDates.forEach((date: string) => {
            if (moment(date).format('dddd') === day) {
                selectedDate = moment(date).format('DD/MM/YYYY');
            }
        });

        if (!selectedDate) {
            return;
        }

        setWorkLocations(prevLocations => {
            const updatedLocations = {
                ...prevLocations,
                [day]: prevLocations[day].map((loc, i) => (i === index ? { ...loc, Place: Place, Date: selectedDate } : loc))
            };
            const existingExceptionIndex: any = workplaceexceptions.filter((exc: WorkplaceException) => exc.Date === selectedDate);

            const selectedLocation = updatedLocations[day][index]; // The specific object being changed

            // Call convertData with only the updated location object
            let prevExceptions = [];
            const existingExceptions = workplaceexceptions || [];
            const isDateInExceptions = existingExceptions.some(existingExc => existingExc.Date === selectedDate);

            if (!isDateInExceptions) {
                prevExceptions = convertData(updatedLocations[day], selectedDate);

            }

            const filteredExceptions = prevExceptions.filter((prevExc: any) => {
                return !existingExceptions.some(existingExc => {
                    return prevExc.Date === existingExc.Date &&
                        prevExc.StartDateTime === existingExc.StartDateTime &&
                        prevExc.EndDateTime === existingExc.EndDateTime;
                });
            });

            let updatedExceptions: WorkplaceException[] = [];
            if (filteredExceptions.length != 0) {
                filteredExceptions.forEach((exception: any) => {
                    if (exception.Id !== null) {
                        updatedExceptions.push({
                            ...exception,
                            Date: exception.Date,
                            StartDateTime: convertTimeString(prevLocations[day][index].StartTime, selectedDate),
                            EndDateTime: convertTimeString(prevLocations[day][index].EndTime, selectedDate),
                            WorkingPlace: Place,
                            Action: 'Edit',
                            Id: exception.Id
                        }
                        )
                    }
                    else {
                        const newException: WorkplaceException = {
                            Date: selectedDate,
                            StartDateTime: convertTimeString(prevLocations[day][index].StartTime, selectedDate),
                            EndDateTime: convertTimeString(prevLocations[day][index].EndTime, selectedDate),
                            WorkingPlace: Place,
                            Id: null, // Set ID as null for new exception
                            Action: 'Add'
                        };

                        updatedExceptions = [...filteredExceptions, newException];
                    }
                })
            }
            else {
                existingExceptionIndex.forEach((exception: any) => {
                    if (exception.Date === selectedDate && exception.StartDateTime === convertTimeString(prevLocations[day][index].StartTime, selectedDate) && exception.EndDateTime === convertTimeString(prevLocations[day][index].EndTime, selectedDate)) {

                        if (exception.Id !== null) {
                            updatedExceptions.push({
                                ...exception,
                                Date: exception.Date,
                                StartDateTime: convertTimeString(prevLocations[day][index].StartTime, selectedDate),
                                EndDateTime: convertTimeString(prevLocations[day][index].EndTime, selectedDate),
                                WorkingPlace: Place,
                                Action: 'Edit',
                                Id: exception.Id
                            })

                        }
                        else {
                            const newException: WorkplaceException = {
                                Date: selectedDate,
                                StartDateTime: convertTimeString(prevLocations[day][index].StartTime, selectedDate),
                                EndDateTime: convertTimeString(prevLocations[day][index].EndTime, selectedDate),
                                WorkingPlace: Place,
                                Id: null, // Set ID as null for new exception
                                Action: 'Add'
                            };

                            updatedExceptions = [...workplaceexceptions, newException];
                        }
                    }
                })
            }



            setWorkplaceexceptions(updatedExceptions);

            // Call updateWorkLocations with the new state
            updateWorkLocations(updatedLocations, updatedExceptions);
            return updatedLocations;
        });
    }

    const convertTimeString = (timeString: any, Selecteddate: any) => {
        const [timePart, period] = timeString.split(' ');
        let [hours, minutes] = timePart.split(':').map(Number);

        if (period && period.toUpperCase() === 'PM') {
            hours = hours === 12 ? 12 : hours + 12;
        } else if (period && period.toUpperCase() === 'AM') {
            hours = hours === 12 ? 0 : hours;
        }

        const date = new Date();
        date.setHours(hours);
        date.setMinutes(minutes);
        const formattedHours = date.getHours().toString().padStart(2, '0');
        const formattedMinutes = date.getMinutes().toString().padStart(2, '0');
        // const Targetdate = moment(Selecteddate).format('DD/MM/YYYY')
        return `${Selecteddate} ${formattedHours}:${formattedMinutes}`;
    };



    const parseTime = (timeStr: any) => {
        const [time, modifier] = timeStr.split(' ');
        let [hours, minutes] = time.split(':').map(Number);

        if (modifier === 'PM' && hours !== 12) {
            hours += 12;
        }
        if (modifier === 'AM' && hours === 12) {
            hours = 0;
        }

        return { hours, minutes };
    };

    const handleAddWorkLocation = async (day: any, locations: any[], use24HourFormat: boolean, index: number) => {
        const latestEndTime = locations.reduce((latest, location) => {
            const { hours, minutes } = parseTime(location.EndTime);
            const totalMinutes = hours * 60 + minutes;

            return totalMinutes > latest ? totalMinutes : latest;
        }, 0);

        const endHours = Math.floor(latestEndTime / 60);
        const endMinutes = Math.ceil((latestEndTime % 60) / 30) * 30; // Round up to the nearest 30 minutes

        let endHourString;
        let endMinuteString;
        let period = ''; // Empty string for 24-hour format

        if (use24HourFormat) {
            endHourString = endHours.toString().padStart(2, '0');
            endMinuteString = endMinutes.toString().padStart(2, '0');
        } else {
            // Determine AM/PM for the latest end time
            period = endHours >= 12 ? 'PM' : 'AM';
            endHourString = (endHours % 12 || 12).toString();
            endMinuteString = endMinutes.toString().padStart(2, '0');
        }

        const endTimeString = use24HourFormat
            ? `${endHourString}:${endMinuteString}`
            : `${endHourString}:${endMinuteString} ${period}`;

        // Use only one format for comparison to avoid ambiguity
        const endTime24HourString = `${endHours.toString().padStart(2, '0')}:${endMinuteString}`;
        const newStartTime = endTimeString;
        let newEndTime: any;
        if (endTime24HourString >= '17:30') {
            const nextEndHours = endHours + 1;
            newEndTime = use24HourFormat
                ? `${nextEndHours.toString().padStart(2, '0')}:${endMinuteString}`
                : `${(nextEndHours % 12 || 12).toString()}:${endMinuteString} ${nextEndHours >= 12 ? 'PM' : 'AM'}`;
        } else {
            newEndTime = use24HourFormat ? '17:30' : '05:30 PM';
        }
        const currentWeekDates = Currentweek;
        let selectedDate: any = null;
        currentWeekDates.forEach((date: string) => {
            if (moment(date).format('dddd') === day) {
                selectedDate = moment(date).format('DD/MM/YYYY');
            }
        });

        await setWorkLocations(prevLocations => {
            // Create a new work location entry for the specified day
            const updatedWorkLocation: any = {
                ...prevLocations,
                [day]: [
                    ...(prevLocations[day] || []),
                    { StartTime: newStartTime, EndTime: newEndTime, Place: 'Office', WorkplaceException: true }
                ]
            };

            // Convert updated work locations to previous exceptions format
            const prevExceptions = convertData(updatedWorkLocation[day], selectedDate);

            // Retrieve existing exceptions from workplaceexceptions state
            const existingExceptions = workplaceexceptions || [];

            // Filter out exceptions that already exist in workplaceexceptions
            const filteredExceptions = prevExceptions.filter((prevExc: any) => {
                return !existingExceptions.some((existingExc: any) => {
                    return prevExc.Date === existingExc.Date &&
                        prevExc.StartDateTime === existingExc.StartDateTime &&
                        prevExc.EndDateTime === existingExc.EndDateTime;
                });
            });

            // Merge existing exceptions with filteredExceptions
            const mergedExceptions = [
                ...existingExceptions,
                ...filteredExceptions
            ];

            // Update state based on the existence of exceptions
            if (existingExceptions.length !== 0) {
                setWorkplaceexceptions(mergedExceptions);
                updateWorkLocations(updatedWorkLocation, mergedExceptions);
            } else {
                setWorkplaceexceptions(prevExceptions);
                updateWorkLocations(updatedWorkLocation, prevExceptions);
            }

            // Return updated work location
            return updatedWorkLocation;
        });

    };

    function convertData(data: any, selectedDate: any) {
        return data.map((item: any) => {
            return {
                Date: selectedDate,
                StartDateTime: convertTimeString(item.StartTime, selectedDate),
                EndDateTime: convertTimeString(item.EndTime, selectedDate),
                WorkingPlace: item.Place,
                Id: null, // Set Id to null for new exception
                Action: 'Add'
            };

        }).filter((entry: any) => entry !== null); // Remove any null values
    }

    function getDateWithOrginal(selectedDate: any, day: string, index: number) {
        if (!selectedDate) {

        }
        else {

            const selectedMoment = moment(selectedDate, 'YYYY-MM-DD').startOf('day');
            const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
            const storedValue = localStorage.getItem('Firstdayofweek');
            const firstDayOfWeek = storedValue === "null" ? 'Monday' : storedValue;
            const today = moment().startOf('day')
            const workingDaysString = localStorage.getItem('Workingdays');
            const workingDays = workingDaysString ? JSON.parse(workingDaysString) : {};
            const isWorkingDay = workingDays[day];
            if (!firstDayOfWeek) {
                throw new Error('First day of the week is not set in localStorage');
            }
            const normalizedFirstDayOfWeek = firstDayOfWeek.charAt(0).toUpperCase() + firstDayOfWeek.slice(1).toLowerCase();
            const firstDayIndex = daysOfWeek.indexOf(normalizedFirstDayOfWeek);
            if (firstDayIndex === -1) {
                throw new Error('Invalid first day of the week');
            }
            let startOfWeek;
            if (selectedMoment.isBefore(today, 'day') && currentweek) {
                startOfWeek = selectedMoment.clone().startOf('isoWeek').isoWeekday(firstDayIndex).startOf('day');

            }
            else {
                startOfWeek = selectedMoment.clone().startOf('isoWeek').isoWeekday(firstDayIndex).startOf('day');

            }

            if (selectedMoment.isAfter(startOfWeek, 'day')) {
                startOfWeek.add(1, 'week');
            }

            if (startOfWeek.isAfter(selectedMoment, 'day')) {
                startOfWeek.subtract(1, 'week');
            }
            if (!currentweek && !isWorkingDay) {
                while (startOfWeek.isBefore(selectedMoment, 'day')) {
                    startOfWeek.add(1, 'week');
                }
            }
            // Calculate the day index of the target day
            const dayIndex = daysOfWeek.indexOf(day);
            // Calculate the difference in days from the start of the week to the target day
            let dayDifference = dayIndex - firstDayIndex;
            if (dayDifference < 0) {
                dayDifference += 7;
            }
            const targetDate = startOfWeek.clone().add(dayDifference, 'days');
            const disableddates = disableCard(targetDate, day, index)
            const formattedDate = targetDate.format('Do');
            const newFormat = `${day} ${formattedDate}`

            const weekDates = [];
            for (let i = 0; i < 7; i++) {
                weekDates.push(selectedMoment.clone().add(i, 'days').format('YYYY-MM-DD'));
            }


            const isToday = targetDate.isSame(today, 'day');
            const isSelected =
                selectedDate &&
                moment(selectedDate, 'YYYY-MM-DD').isSame(targetDate, 'day') &&
                !isToday;
            return {
                disable: disableddates, date: newFormat, isToday: isToday, isSelected: isSelected, targetDate: targetDate, WeekDates: weekDates
            };

        }

    }

    function disableCard(selectedDate: any, day: string, index: number) {
        if (!selectedDate) {
            return false; // Handle case when selectedDate is not provided
        }
        const targetMoment = moment(selectedDate, 'YYYY-MM-DD').startOf('day').toDate();
        const currentDate = moment().startOf('day').toDate();

        // Return true if the targetDate is before or the same as the current date, meaning it should be disabled
        return targetMoment < currentDate;
    }



    function goto(event: any, teams: any) {
        if (event?.target?.tagName !== 'BUTTON') {
            if (teams.Members.length > 0) {
                navigate('/workplace/' + teams.Id + '/' + teams.department);
            }
        }
    }
    const gotosettings = () => {
        navigate('/mysettings/1');
    }

    const currentDayName = moment().format('dddd');
    const workingDaysString = localStorage.getItem('Workingdays');
    const workingDays = workingDaysString ? JSON.parse(workingDaysString) : {};
    const isWorkingDay = workingDays[currentDayName];


    const getActiveDate = () => {
        for (let i = 0; i < rearrangedWeekDays.length; i++) {
            const day = rearrangedWeekDays[i];
            const dateObj = getDateWithOrginal(selectedDate, day, i);
            if (dateObj && dateObj.isToday && workingDays[day]) {
                return moment(dateObj.date, 'dddd Do').format('YYYY-MM-DD');
            }
        }
        return moment(selectedDate).format('YYYY-MM-DD');
    };

    const activeDate = getActiveDate();
    const currentDay = moment().format(dateFormat);
    const isTodayActive = rearrangedWeekDays.some((day, i) => getDateWithOrginal(selectedDate, day, i)?.isToday);
    const deleteMessage1 = t('YouAboutToDeleteTheDataRelatedTo');
    const deleteMessage2 = t("ThisWillAlsoDeleteAllAssociatedDailyDataIncludingTheWorkplacePageAndSoForth")
    const deleteLabel = t("YesDeleteTheDataRelatedTo");

    const handleDeleteWorkLocation = async (day: any, startdateTime: any, EndDatetime: any, Workplace: any, Id: any) => {
        const initialWorkLocations = getSettingsData.data.DefaultWorkPlaces;
        for (const day in initialWorkLocations) {
            if (initialWorkLocations.hasOwnProperty(day)) {
                const updatedTimes = initialWorkLocations[day].map((item: any) => ({
                    ...item,
                    StartTime: convertToTimeString(item.StartTime),
                    EndTime: convertToTimeString(item.EndTime)
                }));
                initialWorkLocations[day] = updatedTimes;
            }
        }

        const currentWeekDates = Currentweek;
        let selectedDate: any | null = null;

        // Find the date corresponding to the given day
        currentWeekDates.forEach((date: string) => {
            if (moment(date).format('dddd') === day) {
                selectedDate = moment(date).format('DD/MM/YYYY');
            }
        });
        const workPlaceExceptions = [{
            Date: selectedDate,
            StartDateTime: convertTimeString(startdateTime, selectedDate),
            EndDateTime: convertTimeString(EndDatetime, selectedDate),
            WorkingPlace: Workplace,
            Id: Id, // Set ID as null for new exception
            Action: 'Remove'
        }]
        console.log(workPlaceExceptions, "workPlaceExceptions");

        try {
            const data = {
                Id: userId,
                EmailAddress: userEmail,
                DefaultWorkPlaces: initialWorkLocations,
                WorkPlaceExceptions: workPlaceExceptions
            };

            const getDataResult = await GetSettingsService.SetWorklocation(data);
            if (getDataResult.data && getDataResult.data?.Updated) {
                ToastrService.success(t('YourWorkPlacesHaveBeenDeletedSucessfully'));
                GetWorklocations();
            } else {
                ToastrService.error(getDataResult.data?.ErrDesc);
            }
        } catch (error) {
        }
    }

    const onBookingSectionDateChange = (date: Date) => {
        setSelectedDate(date);
        setSelectedDatePicker(moment(date).format('YYYY-MM-DD'));
        getUserBookingsApi(moment(date).format('DD/MM/YYYY HH:mm:ss'));
    };

    const [bookingSpaceData, setBookingSpaceData] = useState<ResourceSpaceType| null>(null);
    const [showBookingModel, setShowBookingModel] = useState<boolean>(false);

    const onBookingSpaceTypeSelected = async (item: ResourceSpaceType) => {
        console.log('Selected Booking Type: ', JSON.stringify(item));
        setBookingSpaceData(item);
        setShowBookingModel(true);
    }

    const onBookingCardActionTrigger = (index: number, bookingData: UserBooking, action: BookingCardAction) => {
        console.log('BookingCard Action: ', action);
        console.log('BookingCard Action index: ', index);
        console.log('BookingCard bookingData: ', JSON.stringify(bookingData));

        switch (action) {
            case (BookingCardAction.CheckIn):
                return bookingCheckIn(bookingData);
            case (BookingCardAction.CheckOut):
                return bookingCheckOut(bookingData);
            case (BookingCardAction.Cancel):
                return bookingCancel(bookingData);
            case (BookingCardAction.Extend):
                return bookingExtend(bookingData);
            default:
                return bookingCancel(bookingData);
        }
    }

    const bookingCheckIn = async(data: UserBooking) => {
        try {
            const payload: BookingCheckInRequest = {
                bookid: data.BookingId,
                loginuser: getSettingsData.data.EmailAddress.Value,
                loginusername: `${getSettingsData.data.FirstName} ${getSettingsData.data.LastName}`,
                resid: data.Resource.ResId
            }

            const checkInResponse = await UserBookingService.BookingCheckIn(payload);
            if (checkInResponse.Response && checkInResponse.Response === true) {
                let currentBookingDate = data.Start ? data.Start : data.End ? data.End : new Date()
                getUserBookingsApi(moment(currentBookingDate).format('DD/MM/YYYY HH:mm:ss'));
            }
        } catch(error) {
            ToastrService.error("Something Went Wrong");
        }
    };

    const bookingCheckOut = async(data: UserBooking) => {
        try {
            const payload: BookingCheckOutRequest = {
                bookid: data.BookingId,
                loginuser: getSettingsData.data.EmailAddress.Value,
                loginusername: `${getSettingsData.data.FirstName} ${getSettingsData.data.LastName}`,
                resid: data.Resource.ResId,
                iscleardownaction: 0
            }

            const checkOutResponse = await UserBookingService.BookingCheckOut(payload);
            if (checkOutResponse.Response && checkOutResponse.Response === true) {
                let currentBookingDate = data.Start ? data.Start : data.End ? data.End : new Date()
                getUserBookingsApi(moment(currentBookingDate).format('DD/MM/YYYY HH:mm:ss'));
            }
        } catch(error) {
            ToastrService.error("Something Went Wrong");
        }
    };

    const bookingCancel = async(data: UserBooking) => {
        try {
            const payload: CancelBookingRequest = {
                bookingid: data.BookingId,
                parentBookingId: data.ParentBookingId,
                userid: userId
            }

            const cancelResponse = await UserBookingService.BookingCancel(payload);
            if (cancelResponse.Response && cancelResponse.Response === true) {
                let currentBookingDate = data.Start ? data.Start : data.End ? data.End : new Date()
                getUserBookingsApi(moment(currentBookingDate).format('DD/MM/YYYY HH:mm:ss'));
            }
        } catch(error) {
            ToastrService.error("Something Went Wrong");
        }
    };

    const bookingExtend = async(data: UserBooking) => {
        try {
            const payload: ExtendBookingRequest = {
                addmins: "30",
                bookid: data.BookingId,
                loginuser: getSettingsData.data.EmailAddress.Value,
                loginusername: `${getSettingsData.data.FirstName} ${getSettingsData.data.LastName}`,
                resid: data.Resource.ResId,
                extendedfrom: null
            }

            const extendResponse = await UserBookingService.BookingExtend(payload);
            if (extendResponse.Response && extendResponse.Response === true) {
                let currentBookingDate = data.Start ? data.Start : data.End ? data.End : new Date()
                getUserBookingsApi(moment(currentBookingDate).format('DD/MM/YYYY HH:mm:ss'));
            }
        } catch(error) {
            ToastrService.error("Something Went Wrong");
        }
    };

    const scrollRef = useRef<HTMLDivElement | null>(null);
    const [isDragging, setIsDragging] = useState(false);
    const startX = useRef(0);
    const scrollLeft = useRef(0);

    const onMouseDown = (e: React.MouseEvent) => {
        if (!scrollRef.current) return;
        setIsDragging(true);
        startX.current = e.pageX - scrollRef.current.offsetLeft;
        scrollLeft.current = scrollRef.current.scrollLeft;
    };

    const onMouseLeave = () => setIsDragging(false);
    const onMouseUp = () => setIsDragging(false);

    const onMouseMove = (e: React.MouseEvent) => {
        if (!isDragging || !scrollRef.current) return;
        e.preventDefault();
        const x = e.pageX - scrollRef.current.offsetLeft;
        const walk = (x - startX.current) * 1.2; // scroll speed
        scrollRef.current.scrollLeft = scrollLeft.current - walk;
    };

    const handleCardClick = (
        e: React.MouseEvent<HTMLDivElement>,
        day: any,
        index: number
    ) => {

        // Ignore interactive elements
        const target = e.target as HTMLElement;
        const card = e.currentTarget;
        const IGNORE_SELECTOR = `
            button,
            input,
            select,
            textarea,
            [role="listbox"],
            [role="option"],
            [role="combobox"],
            .img_show,
            .img_show_dark,
            .date_cards,
            .add_btn
        `;

        const ignoredElement = target.closest(IGNORE_SELECTOR);

        // Ignore only if the matched element is NOT the card itself
        if (ignoredElement && !card.contains(ignoredElement)) {
            return;
        }

        const dateObj = getDateWithOrginal(selectedDate, day, index)?.targetDate?.toDate();

        if (dateObj) {
            setSelectedDate(dateObj);
            setSelectedDatePicker(moment(dateObj).format('YYYY-MM-DD'));
            getUserBookingsApi(moment(dateObj).format('DD/MM/YYYY HH:mm:ss'));
        }
    };

    const onCloseBookingModel = () => {
        setShowBookingModel(false) 
        setBookingSpaceData(null)
    };

    return (
        <div className={`sidenav-container`}>
            <Sidenav authToken={null} LoguserName={null} />
            <div className={theme === 'dark' ? 'main-content_dark' : 'main-content'}>
                <div className={`${theme === 'dark' ? ' card card_dark' : 'card'} mx-1`}>
                    <div className="row card_row_head">
                        <div className="col-10 col-xl-px-4 col-lg-px-4 col-md-px-4 col-sm-px-2">
                            <span ><Greetings />  &nbsp;<span className='user_name'>{localStorage.getItem('UserName')}</span></span>
                        </div>
                        <div className="col-2 right px-4">
                            <Menu>
                                <MenuTrigger disableButtonEnhancement>
                                    <Avatar
                                        name={localStorage.getItem('UserName')?.toString()}
                                        image={{
                                            src: getSettingsData.data && getSettingsData.data.UserImage && getSettingsData.data.UserImage.Value
                                                ? getSettingsData.data.UserImage.Value
                                                : "",
                                        }}
                                        style={{
                                            cursor: "pointer", width: "48px", height: "48px"
                                        }}
                                        shape="circular"
                                    />
                                </MenuTrigger>
                                <MenuPopover className='mt-2' style={{ width: "14rem" }}>
                                    <MenuList>
                                        {/* <MenuItem style={{ fontSize: "14px" }} ><Image id="img" className='pointer' src={CommonInfo.folderName + "resetpassword.svg"} />&nbsp;&nbsp;Reset password</MenuItem> */}
                                        <MenuItem onClick={logOut} style={{ fontSize: "14px" }} ><Image id="img" className='pointer' src={`${CommonInfo.folderName}${theme === 'dark' ? '/Logoutlight.svg' : '/logout.svg'}`}
                                        />&nbsp;&nbsp;{t('LogOut')}</MenuItem>
                                    </MenuList>
                                </MenuPopover>
                            </Menu>
                            {ToastrService.getToastrComponent()}
                        </div>
                    </div>
                </div>
                <div className='row gx-4'>
                    <div className="col-xl-9 col-lg-9 col-md-12">
                        <div className="row  mt-3 mb-0">
                            <div className="col-md-12 px-0 ps-4">
                                <label className={theme === 'dark' ? 'head_dark' : 'head'}>{t('WorkPlaces')}</label>
                                <hr />
                            </div>
                        </div>
                        <div className="row px-3">
                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 center_flex">
                                <img
                                    id="icon"
                                    style={{ width: "20px" }}
                                    className="pointer"
                                    src={`${CommonInfo.folderName}${theme === 'dark' ? '/Calandarlight.svg' : '/datepicker.svg'}`}
                                    onClick={handleIconClick}
                                    alt="Calendar Icon"
                                />

                                {selectedDate && (
                                    <span onClick={handleIconClick} className={theme === 'dark' ? 'span_head px-2 date pointer' : 'px-2 date pointer'}>{moment(currentweekDates[0]).format(dateFormat ? dateFormat : 'dddd Do MMMM YYYY')} - {moment(currentweekDates[currentweekDates.length - 1]).format(dateFormat ? dateFormat : 'dddd Do MMMM YYYY')}
                                    </span>
                                )} &nbsp;
                                <span><Image onClick={() => setRightLeftDate('left')} className={theme === 'dark' ? 'pointer img_hover' : 'pointer img_hover_light'} src={`${CommonInfo.folderName}${theme === 'dark' ? '/leftarrowlight.svg' : '/leftarrow.svg'}`}
                                />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <Image onClick={() => setRightLeftDate('right')} className={theme === 'dark' ? 'pointer img_hover' : 'pointer img_hover_light'} src={`${CommonInfo.folderName}${theme === 'dark' ? '/rightarrowlight.svg' : '/rightarrow.svg'}`} />
                                </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                {!isTodayActive && moment().format(dateFormat) !== moment(selectedDate).format(dateFormat) && isWorkingDay && (
                                    <span className='col-xl-px-3 col-lg-px-3 col-md-px-3 col-sm-px-0'>
                                        <button className={theme === 'dark' ? 'calendar_btn_dark' : 'calendar_btn'} onClick={setTodayDate}>
                                            <img
                                                id="button_icon"
                                                style={{ width: "20px" }}
                                                className='pointer'
                                                src={`${CommonInfo.folderName}${theme === 'dark' ? '/Calandarlight.svg' : '/datepicker.svg'}`}
                                                alt="Calendar Icon"
                                            />
                                            &nbsp;&nbsp;{t('Today')}
                                        </button>
                                    </span>
                                )}
                                {/* {isCalendarVisible && ( */}
                                <div className="calendar-container">
                                    <DatePicker className={theme === 'dark' ? 'Dark_calender' : ""} value={selectedDatePicker ? dayjs(selectedDatePicker) : null} onChange={handleDateSelect} open={isCalendarVisible}
                                        disabledDate={isDayDisabled}
                                    />
                                </div>
                                {/* )} */}
                            </div>
                        </div>
                        <div ref={scrollRef} className="row workplace mt-3 p-3 row_height hide-scrollbar" style={{ display: 'flex', flexWrap: 'nowrap', overflowX: 'auto', scrollBehavior: 'smooth', gap: '10px' }}
                            onMouseDown={onMouseDown}
                            onMouseLeave={onMouseLeave}
                            onMouseUp={onMouseUp}
                            onMouseMove={onMouseMove}>
                            {/* <div> */}
                            {Workplaces && (
                                <div>
                                    <label className={theme === 'dark' ? 'label-head_dark lock-icon ' : 'label-head lock-icon '}>
                                        {t('YourDefaultWorkLocationsAreNotConfiguredPleaseConfigureItNow')}
                                    </label>
                                    <button type="button" onClick={gotosettings} className={theme === 'dark' ? 'generate_bttn_dark mt-4' : 'generate_bttn mt-4'} ><FontAwesomeIcon icon={faCog} />&nbsp;&nbsp;{t('Configure')}</button>
                                </div>
                            )}
                            {/* </div> */}
                            {rearrangedWeekDays?.map((day: any, i) => (
                                <div
                                    role="button"
                                    key={day}
                                    style={{ minWidth: '200px', maxWidth: '250px', minHeight: '200px', maxHeight: hoveredCard === i ? '220px' : '200px', transition: 'max-height 0.3s ease-in-out', padding: '10px 10px 10px 10px', flex: '1 0 220px', overflow: 'hidden' }}
                                    className={`card 
                                        ${theme === 'dark' ? 'card_dark' : ''} 
                                        ${getDateWithOrginal(selectedDate, day, i)?.isToday ? 'active_border' : ''} 
                                        ${getDateWithOrginal(selectedDate, day, i)?.isSelected ? theme === 'dark' ? 'selected_border_light' : 'selected_border' : ''}
                                        ${getDateWithOrginal(selectedDate, day, i)?.disable ? 'disabled' : ''} 
                                        ${workLocations[day].length === 0 ? 'hidden' : ''}`
                                    }
                                    onClick={(e) => handleCardClick(e, day, i)}
                                    onMouseDown={(e) => e.stopPropagation()}
                                >
                                    {/* <div key={day}> */}
                                    <p style={{ height: '26px', paddingLeft: 4, paddingRight: 4 }} className={`${theme === 'dark' ? 'headers_dark' : 'headers'} ${getDateWithOrginal(selectedDate, day, i)?.disable ? 'disabled' : ''}`}>{getDateWithOrginal(selectedDate, day, i)?.date}</p>
                                    <div style={{ overflowX: 'hidden', overflowY: 'auto', marginTop: -10 }}>
                                        {workLocations[day] ? workLocations[day]?.map((location: any, index: number) => (
                                            <div key={index} className="date_cards" style={{}}>
                                                <div className={`${theme === 'dark' ? 'Dark_timepicker card_time_picker_dark row g-0 mt-1' : "row g-0 mt-1 card_time_picker "}`} style={{ alignItems: 'center', padding: 0, overflow: 'hidden', justifyContent: 'space-between' }}>
                                                    <div className='row' style={{ flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center' }}>
                                                        <div className="col-5 p-0">
                                                            <CustomTimePicker
                                                                disabled={getDateWithOrginal(selectedDate, day, i)?.disable}
                                                                value={location.StartTime}
                                                                onTimeChange={(event, data) => handleTimeChange(day, index, 'StartTime', data)} isFormattedTime={getSettingsData.data['Is24HrFormat']} />
                                                        </div>

                                                        <div className="col-1 p-0" style={{ textAlign: 'center', color: theme === 'dark' ? "#fff" : '#000' }}>
                                                            -
                                                        </div>
                                                        <div className="col-5 p-0">
                                                            <CustomTimePicker disabled={getDateWithOrginal(selectedDate, day, i)?.disable}
                                                                value={location.EndTime}
                                                                onTimeChange={(event, data) => handleTimeChange(day, index, 'EndTime', data)} isFormattedTime={getSettingsData.data['Is24HrFormat']} />
                                                        </div>
                                                    </div>

                                                    <div className="col-1 lg:px-4" style={{ marginRight: 5 }} >
                                                        {getSettingsData.GetWorkLocationdata.WorkPlaceExceptions !== null && !(getDateWithOrginal(selectedDate, day, i)?.disable) && location.WorkplaceException && <DeleteAction className={theme === 'dark' ? 'pointer delete_icon_dark' : 'pointer delete_icon '} deleteMessage1={deleteMessage1} deleteMessage2={deleteMessage2} deleteLabel={deleteLabel} Day={day + ' at ' + location.StartTime + '-' + location.EndTime}
                                                            triggerdelete={() => handleDeleteWorkLocation(day, location.StartTime, location.EndTime, location.Place, location.Id)} />}
                                                    </div>
                                                </div>

                                                <div className='row'>
                                                    <div className="col-12" style={{ width: '100%' }}>
                                                        <CustomOptionsDropdown
                                                            workplaceList={getSettingsData.workPlacelist}
                                                            disabled={getDateWithOrginal(selectedDate, day, i)?.disable}
                                                            value={location.Place}
                                                            onOptionSelect={(event, data) => handleDropdownChange(day, index, data.optionValue, getSettingsData?.GetWorkLocationdata?.WorkplaceException)}
                                                            style={{ width: '100%', backgroundColor: theme === 'dark' ? getDateWithOrginal(selectedDate, day, i)?.disable ? "rgba(255, 255, 255, 0.1)" : "#124779" : getDateWithOrginal(selectedDate, day, i)?.disable ? "rgba(234, 239, 245, 1)" : "#C9E1F8", color: "#0000", textOverflow: "ellipsis", fontWeight: "bold" }} />
                                                    </div>
                                                </div>
                                            </div>

                                        )) : []
                                        }
                                    </div>
                                    {
                                        !getDateWithOrginal(selectedDate, day, i)?.disable && (
                                            <div style={{ padding: 0, minHeight: '20px', maxHeight: '47px', width: '100%' }} className={` ${theme === 'dark' ? getDateWithOrginal(selectedDate, day, i)?.disable ? 'footers_dark' : 'menu_icon footers_dark' : getDateWithOrginal(selectedDate, day, i)?.disable ? 'footers' : 'menu_icon footers'}`}
                                                onMouseEnter={() => getDateWithOrginal(selectedDate, day, i)?.disable ? '' : handleCardHover(i)}
                                                onMouseLeave={handleMouseLeave}>
                                                <div className={`pointer dot_icon ${getDateWithOrginal(selectedDate, day, i)?.disable ? 'disabled' : ''}`}>
                                                    {/* <svg width="20" height="18" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M11.1584 7.99996C11.1584 7.8563 11.2155 7.71852 11.317 7.61694C11.4186 7.51536 11.5564 7.45829 11.7001 7.45829C11.8437 7.45829 11.9815 7.51536 12.0831 7.61694C12.1847 7.71852 12.2417 7.8563 12.2417 7.99996C12.2417 8.14361 12.1847 8.28139 12.0831 8.38297C11.9815 8.48455 11.8437 8.54162 11.7001 8.54162C11.5564 8.54162 11.4186 8.48455 11.317 8.38297C11.2155 8.28139 11.1584 8.14361 11.1584 7.99996ZM8.11705 8.38297L7.74582 8.7542L8.11705 8.38297C8.01547 8.28139 7.9584 8.14361 7.9584 7.99996C7.9584 7.8563 8.01547 7.71852 8.11705 7.61694C8.21863 7.51536 8.35641 7.45829 8.50006 7.45829C8.64372 7.45829 8.7815 7.51536 8.88308 7.61694C8.98466 7.71852 9.04173 7.8563 9.04173 7.99996C9.04173 8.14361 8.98466 8.28139 8.88308 8.38297C8.7815 8.48455 8.64372 8.54162 8.50006 8.54162C8.35641 8.54162 8.21863 8.48455 8.11705 8.38297ZM5.68308 8.38297L6.05431 8.7542L5.68308 8.38297C5.5815 8.48455 5.44372 8.54162 5.30007 8.54162C5.15641 8.54162 5.01863 8.48455 4.91705 8.38297C4.81547 8.28139 4.7584 8.14361 4.7584 7.99996C4.7584 7.8563 4.81547 7.71852 4.91705 7.61694C5.01863 7.51536 5.15641 7.45829 5.30007 7.45829C5.44372 7.45829 5.5815 7.51536 5.68308 7.61694C5.78466 7.71852 5.84173 7.8563 5.84173 7.99996C5.84173 8.14361 5.78466 8.28139 5.68308 8.38297Z"
                                                    fill={`${theme === 'dark' ? getDateWithOrginal(selectedDate, day, i)?.disable ? '#b0b0b0' : '#fff' : getDateWithOrginal(selectedDate, day, i)?.disable ? '#a7a7a7' : 'black'}`} stroke={`${theme === 'dark' ? getDateWithOrginal(selectedDate, day, i)?.disable ? '#b0b0b0' : '#fff' : getDateWithOrginal(selectedDate, day, i)?.disable ? '#a7a7a7' : 'black'}`} stroke-width="1.05" />
                                            </svg> */}

                                                    <img src={`${CommonInfo.folderName}${theme === 'dark' ? '/threedot.svg' : '/threedotdark.svg'}`} />
                                                </div>
                                                {
                                                    hoveredCard === i && (
                                                        <div className='add_btn'>
                                                            <button className={theme === 'dark' ? 'img_show_dark' : 'img_show'} onClick={() => handleAddWorkLocation(day, workLocations[day], getSettingsData.data['Is24HrFormat'], i)}>
                                                                <Image id={theme === 'dark' ? 'add_img_dark' : "add_img"} className='pointer'
                                                                    src={`${CommonInfo.folderName}${theme === 'dark' ? '/plus_circlelight.svg' : '/plus-circle.svg'}`} />
                                                                &nbsp;&nbsp;{t('Add')}
                                                            </button>
                                                        </div>
                                                    )
                                                }



                                            </div>
                                        )
                                    }

                                </div>
                            ))}
                        </div>
                        <div className="row mt-4 mb-0">
                            <div className="col-md-12 px-4">
                                <label className='head'>{t('MyTeams')}</label>
                                <hr />
                            </div>
                        </div>
                        <div className='mb-4'>
                            <div className="card_row">
                                {getSettings.MysettingsBasicdata?.[0]?.Teams?.length > 0 ? getSettings.MysettingsBasicdata?.[0].Teams?.map((team: any, index: number) => (
                                    <div key={index} className={` mb-2 px-1 ${team.Members.length > 0 ? 'pointer' : ''}`} onClick={(event) => { goto(event, team); }}>
                                        <div className={theme === 'dark' ? 'card teams_card card_dark' : "card teams_card"} >
                                            <span className={theme === 'dark' ? 'teams_header_dark' : 'teams_header'}>{team.Name}</span>
                                            <p className={theme === 'dark' ? 'teams_designation_dark' : 'teams_designation'}>{team.department ? team.department : <p style={{ visibility: "hidden" }}></p>}</p>
                                            {/* Assuming inlineItems and overflowItems are part of the team object */}
                                            {team.Members.length ? (
                                                team.Members.length > 0 && (
                                                    <AvatarGroup className="justify_right" size={32}>
                                                        {/* Filter out the current user first */}
                                                        {team.Members.filter((name: any) => name.Id !== userId)
                                                            .slice(0, 6)
                                                            .map((name: any, idx: number) => (
                                                                <div key={idx}>
                                                                    <AvatarGroupItem
                                                                        name={`${name.FirstName} ${name.LastName}`}
                                                                        image={{
                                                                            src:
                                                                                name.UserImage &&
                                                                                    name.UserImage !== "null" &&
                                                                                    name.UserImage !== null &&
                                                                                    name.UserImage !== ""
                                                                                    ? name.UserImage
                                                                                    : "",
                                                                        }}
                                                                        initials={`${name.name ? name.name : ""}`} // Display initials if no image
                                                                    />
                                                                </div>
                                                            ))}

                                                        {/* Show AvatarGroupPopover with the remaining count */}
                                                        {team.Members.filter((name: any) => name.Id !== userId).length > 6 && (
                                                            <AvatarGroupPopover
                                                                count={
                                                                    team.Members.filter((name: any) => name.Id !== userId).length - 6
                                                                }
                                                            >
                                                                {team.Members.filter((name: any) => name.Id !== userId)
                                                                    .slice(6)
                                                                    .map((name: any, f: number) => (
                                                                        <AvatarGroupItem
                                                                            key={f}
                                                                            name={`${name.FirstName} ${name.LastName}`}
                                                                            image={{
                                                                                src:
                                                                                    name.UserImage &&
                                                                                        name.UserImage !== "null" &&
                                                                                        name.UserImage !== null &&
                                                                                        name.UserImage !== ""
                                                                                        ? name.UserImage
                                                                                        : "",
                                                                            }}
                                                                            initials={`${name.name ? name.name : ""}`}
                                                                        />
                                                                    ))}
                                                            </AvatarGroupPopover>
                                                        )}
                                                    </AvatarGroup>
                                                )
                                            ) : (
                                                <div>
                                                    <p style={{ visibility: "hidden" }}>.</p>
                                                </div>
                                            )}

                                        </div>
                                    </div>
                                )) : <div className="col-xl-3 col-lg-3 col-md-5 col-sm-4 mb-2 px-1">
                                    <div className={theme === 'dark' ? 'card teams_card card_dark' : "card teams_card"}>
                                        <h6 className={theme === 'dark' ? 'teams_header_dark' : "teams_header"}>No data available. Contact your administrator to update these settings.</h6>
                                    </div>
                                </div>}
                            </div>
                        </div>
                    </div>

                    <div className="col-xl-3 col-lg-3 col-md-12 my-3">
                        <div className='px-0 mx-0'>
                            <UserBookings
                                theme={theme}
                                dateFormat={dateFormat}
                                selectedDate={selectedDate}
                                resourceSpaceData={resourcespacetypeList}
                                userBookings={userBookings}
                                onDateChange={onBookingSectionDateChange}
                                onSpaceTypeSelect={onBookingSpaceTypeSelected}
                                onBookingCardAction={onBookingCardActionTrigger}
                            />
                        </div>
                    </div>
                    <div>
                        {(showBookingModel && bookingSpaceData) && <ResourceSpaceTypeModel spaceDetails={bookingSpaceData} allSpaceTypes={resourcespacetypeList} selectedDate={selectedDate} onCloseModel={onCloseBookingModel} />}
                    </div>
                </div>
            </div>
        </div >
    );

};

export default WorkPlacePage;